// extracted by mini-css-extract-plugin
export default {"container":"Fz-z","dimension":"Gz-z","dimensionLabels":"Hz-z"};